// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./PageTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page-module__Container__sGlHS {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--ds-9x);
    height: var(--ds-9x);
    color: var(--ds-page-color);
    border-radius: var(--ds-border-radius-sm);
    cursor: pointer;
    user-select: none;
}

.Page-module__Container__sGlHS:hover {
    color: var(--ds-page-hover-color);
}

.Page-module__Container__sGlHS:focus-visible {
    color: var(--ds-page-hover-color);
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: var(--ds-05x);
}

.Page-module__Selected__BJli6 {
    background-color: var(--ds-page-selected-bg-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Page-module__Container__sGlHS`,
	"Selected": `Page-module__Selected__BJli6`
};
export default ___CSS_LOADER_EXPORT___;
